export default (vehicle) => {
  const hpMonthlyPayment = vehicle.hpFinance.monthlyPayment
  const pcpMonthlyPayment = vehicle.pcpFinance.monthlyPayment
  const vehiclePayment = {
    total: vehicle.value,
    installment: {
      payment: hpMonthlyPayment,
      plan: 'Mth',
      code: 'MON',
      type: 'hp'
    },
    reserve: vehicle.reservePrice
  }
  let finance = vehicle.hpFinance

  if (
    pcpMonthlyPayment &&
    (!hpMonthlyPayment || hpMonthlyPayment > pcpMonthlyPayment)
  ) {
    vehiclePayment.installment.payment = pcpMonthlyPayment
    vehiclePayment.installment.type = 'pcp'
    finance = vehicle.pcpFinance
  }

  return { finance, vehiclePayment }
}
